var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid px-3 pl-md-5 pr-md-2"},[_c('div',{staticClass:"row mt-3 p-0"},[_vm._m(0),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 col-xl-3 text-center mb-4"},[_c('img',{staticClass:"logo-image p-0",attrs:{"src":"/images/adventures/logo-va.png"}})])
}]

export { render, staticRenderFns }